// extracted by mini-css-extract-plugin
export default {"navIcon":"styles_navIcon__qxBQO"};